import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { UserRole } from '../types/user';

interface RequireAdminProps {
    redirectTo?: string;
    extraRoles?: UserRole[];
}

export const RequireAdmin = ({ redirectTo = '/dashboard', extraRoles = [] }: RequireAdminProps) => {
    const location = useLocation();
    const isAuthenticated = useSelector((state: RootState) => !!state.user.jwtToken);
    const role = useSelector((state: RootState) => state.user.role) as UserRole | undefined;

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location.pathname }} />;
    }

    const allowed = role === UserRole.ADMIN || (role !== undefined && extraRoles.includes(role));
    return allowed ? <Outlet /> : <Navigate to={redirectTo} replace />;
};


